import { PRELOAD_LOGGED_OUT_APP_MODAL_110824 } from "@faire/web-api/indigofair/settings/PRELOAD_LOGGED_OUT_APP_MODAL_110824";

import { useAssignSetting } from "@faire/retailer/settings/__internal__/useSetting";
import { useBooleanSetting } from "@faire/retailer/settings/useBooleanSetting";

export const useSettingPreloadLoggedOutAppModal = () => {
  return useBooleanSetting(PRELOAD_LOGGED_OUT_APP_MODAL_110824);
};

export const useAssignSettingPreloadLoggedOutAppModal = () => {
  return useAssignSetting(PRELOAD_LOGGED_OUT_APP_MODAL_110824);
};
